// src/routes/RecordingExertionRecoveryRouter.jsx
import React, { Suspense, lazy } from "react";
import { ClipLoader } from "react-spinners"; // ✨ spinner

const RecordingExertionRecovery = lazy(() =>
  import("recordingExertionRecovery/App")
);

export default function RecordingExertionRecoveryRouter(props) {
  // console.log("router");

  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingExertionRecovery {...props} />
    </Suspense>
  );
}
